import { Element } from '../../../common/html/element'
import { ButtonGroup } from './ButtonGroup'
import { FilterCompany } from './FilterCompany'
import classes from './index.module.scss'
import { Title } from './Title'

export const Header = ({ renderCustomHeader }) => {
  return (
    <Element
      className={classes.header}
      style={{ borderColor: '#E5E5E8', color: '#3A414B' }}
    >
      <div className="dFlex justifyContentBetween">
        <Title />
        <ButtonGroup />
      </div>

      {renderCustomHeader && renderCustomHeader()}

      <FilterCompany />
    </Element>
  )
}
